import React from "react"
import { PageContent, CustomBreadcrumb } from "components/Common";

import { ModuleIds } from "constant";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import ERPProduct from "./ERPProduct";

const RESOURCE = ModuleIds.ERPProduct;

const ERPProductContainer = ({ t }) => {
    const titleTag = t("Danh sách sản phẩm ERP");

    return (
        <PageContent title={t(titleTag)}>
            {/* Page Title */}
            < CustomBreadcrumb
                breadcrumbItem={titleTag}
                resource={RESOURCE}               
                icon={<i className="bx bx-file" />}
            />
            {/* Page Body */}
            <ERPProduct />          
        </PageContent >
    )
}

ERPProductContainer.propTypes = {
    t: PropTypes.any,
}

export default withTranslation(["erpProductPage"])(ERPProductContainer)